import { IGoal } from "motw_core/Entity/IGoal";
import * as React from "react";
import { FormInput } from "../../../../Shared/Form/Input/FormInput";
import { CanSaveProperty } from "./CanSaveProperty";
import { emptyIGEPStateContainer } from "./GEPState/emptyGEPStateContainer";
import { GoalEditorPanel } from "./GoalEditorPanel";
import { HandleValueChange } from "./HandleValueChange";
import { FormTextArea } from "../../../../Shared/Form/TextArea/FormTextArea";

export function GetGEPTextAreaBox(
    GEP: GoalEditorPanel,
    options: GEPTextAreaBoxOptions
) {
    const propertyName = options.property.toString();
    let value = GEP.state.currentState[propertyName];

    return (
        <div>
            <FormTextArea
                id={`goal_${propertyName}`}
                label={propertyName}
                width={options.width || "190px"}
                value={value}
                onChange={(value) =>
                    HandleValueChange(GEP, value, propertyName)
                }
                onClear={() =>
                    HandleValueChange(
                        GEP,
                        emptyIGEPStateContainer[propertyName],
                        propertyName
                    )
                }
                readonly={!CanSaveProperty(propertyName)}
            />
        </div>
    );
}
interface GEPTextAreaBoxOptions {
    property: keyof IGoal;
    width?: string;
}
